import { TableUserListCell } from '../../Table'
import { toUserMultiValue } from '../../User'

import {
  getEmailTableRowParticipants,
  sortParticipantsMoreItems,
} from './EmailTableRowParticipants.utils'

function EmailTableRowParticipants({
  getItems = getEmailTableRowParticipants,
  item,
  scrollRef,
  sortMoreItems = sortParticipantsMoreItems,
  ...restProps
}) {
  const { last_message: email, unread } = item

  const items = getItems(email || item).map(toUserMultiValue)

  return (
    <TableUserListCell
      {...restProps}
      scrollRef={scrollRef}
      sortMoreItems={sortMoreItems}
      unread={unread}
      value={items}
    />
  )
}

export default EmailTableRowParticipants
